import { useState, useEffect } from 'react';

export function useToast(duration = 1600) {
  const [show, setShow] = useState(false);
  // Bumped on every trigger, so a toast shown while one is up gets a full duration.
  const [shownAt, setShownAt] = useState(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (show) {
      timer = setTimeout(() => {
        setShow(false);
      }, duration);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [show, shownAt, duration]);

  const trigger = () => {
    setShow(true);
    setShownAt(Date.now());
  };

  return { show, trigger };
}
